import {Component, Vue} from 'vue-property-decorator';
import Search from '@/components/Search/index.vue';
import IssuesList from '@/components/IssuesList/index.vue';
import {Getter} from 'vuex-class';
import {GameInterface} from '@/store/modules/games/types';

@Component({
    name: 'v-reported-issues-game',
    components: {
        'c-search': Search,
        'c-issues-list': IssuesList,
    },
})


export default class ReportedIssuesGame extends Vue {

    // Games
    @Getter('getCurrentGame', {namespace: 'gamesStateModule'})
    public getCurrentGame!: GameInterface;

    // Get background image
    @Getter('backgroundImage', {namespace: 'settingsModule'})
    public backgroundImage!: string;

    /**
     * Background styles
     * @param {string} keyArtUrl
     * @return {string}
     */
    public getBackgroundStyles(keyArtUrl: string): string {
        return  'background-image: linear-gradient(70deg, rgba(255,255,255,1) 0%, ' +
            'rgba(255,255,255,0.9) 60%, ' +
            'rgba(255,255,255,0) 100%), ' +
            'url("' + keyArtUrl + '");';
    }
}
